module.exports = __webpack_public_path__ + "img/Matematicas IV.b08483d5.png";